module.exports = {"meta":"Impressum"}


//////////////////
// WEBPACK FOOTER
// ./src/assets/i18n/lang/de/imprint.json
// module id = edUW
// module chunks = 1